import React from "react";
import { CANONICAL_COLUMNS } from "./Columns";

export const CsvPreviewTable = ({ previewData }) => {
  if (!previewData || previewData.length === 0) return null;

  const hasPaymentLinks = previewData.some(
    (row) =>
      row[CANONICAL_COLUMNS.STRIPE_LINK] &&
      row[CANONICAL_COLUMNS.STRIPE_LINK].trim() !== ""
  );

  const displayValue = (value) =>
    value === undefined || value === null || value === "" ? (
      <span className="text-red-600 font-medium">N/A</span>
    ) : (
      value
    );

  return (
    <div className="p-4 bg-accent/50 rounded-md border border-accent">
      <p className="font-semibold mb-3">
        📊 Data Preview (First {Math.min(previewData.length, 10)} rows):
      </p>
      <div className="overflow-x-auto">
        <div className="max-h-[220px] scrollbar-none border-accent overflow-y-auto border rounded-md">
          <table className="w-full text-xs border-collapse">
            <thead className="sticky top-0 text-orange-100 bg-orange-900 z-10">
              <tr className="border-b">
                <th className="text-left p-2 font-medium">Year</th>
                <th className="text-left p-2 font-medium">Make</th>
                <th className="text-left p-2 font-medium">Model</th>
                <th className="text-left p-2 font-medium">Part Name</th>
                <th className="text-left p-2 font-medium">Category</th>
                <th className="text-left p-2 font-medium">Price</th>
                <th className="text-left p-2 font-medium">Qty</th>
                <th className="text-left p-2 font-medium">Postal</th>
                {hasPaymentLinks && (
                  <th className="text-left p-2 font-medium">Payment</th>
                )}
                <th className="text-left p-2 font-medium">Status</th>
              </tr>
            </thead>
            <tbody className="text-gray-950 bg-orange-50">
              {previewData.slice(0, 10).map((row, index) => (
                <tr
                  key={index}
                  className={`border-b ${row.hasErrors ? "bg-red-50" : ""}`}
                >
                  <td className="p-2">
                    {displayValue(row[CANONICAL_COLUMNS.YEAR])}
                  </td>
                  <td className="p-2">
                    {displayValue(row[CANONICAL_COLUMNS.MAKE])}
                  </td>
                  <td className="p-2">
                    {displayValue(row[CANONICAL_COLUMNS.MODEL])}
                  </td>
                  <td className="p-2">
                    {displayValue(row[CANONICAL_COLUMNS.PART_NAME])}
                  </td>
                  <td className="p-2">
                    {displayValue(row[CANONICAL_COLUMNS.PART_CATEGORY])}
                  </td>
                  <td className="p-2">
                    {row[CANONICAL_COLUMNS.PRICE] !== undefined &&
                    row[CANONICAL_COLUMNS.PRICE] !== "" ? (
                      `$${row[CANONICAL_COLUMNS.PRICE]}`
                    ) : (
                      <span className="text-red-600 font-medium">N/A</span>
                    )}
                  </td>
                  <td className="p-2">
                    {displayValue(row[CANONICAL_COLUMNS.QUANTITY])}
                  </td>
                  <td className="p-2">
                    {displayValue(row[CANONICAL_COLUMNS.POSTAL_CODE])}
                  </td>
                  {hasPaymentLinks && (
                    <td
                      className="p-2 max-w-[100px] truncate"
                      title={row[CANONICAL_COLUMNS.STRIPE_LINK] || "N/A"}
                    >
                      {row[CANONICAL_COLUMNS.STRIPE_LINK] ? (
                        <a
                          href={row[CANONICAL_COLUMNS.STRIPE_LINK]}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-600 hover:underline"
                        >
                          Payment Link
                        </a>
                      ) : (
                        <span className="text-gray-400">N/A</span>
                      )}
                    </td>
                  )}
                  <td className="p-2">
                    {row.hasErrors ? "❌ Errors" : "✅ Valid"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
